import { ITypographyComponentProps, ModalWindow, TDeviceType, TMemoForwardRefComponent } from '@cian/ui-kit';
import * as style from './styles.css';
import { AnswersOnQuestionsItem } from '../AnswersOnQuestionsItem';
import { clsx } from 'clsx';
import { IAnswersOnQuestions } from 'shared/types/answersOnQuestions';
import { plural } from '@cian/utils';

interface IAnswersOnQuestionsProps {
  answersOnQuestions: IAnswersOnQuestions[];
  device: TDeviceType;
  modalVisible: boolean;
  activeBlock: IAnswersOnQuestions;
  BlockTitle: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
  onCloseModal: VoidFunction;
  onActiveBlock: (block: IAnswersOnQuestions) => void;
  onQuestionClick: (question: string, isOpen: boolean) => void;
}

export const AnswersOnQuestions: React.FC<IAnswersOnQuestionsProps> = ({
  device,
  answersOnQuestions,
  activeBlock,
  modalVisible,
  BlockTitle,
  onActiveBlock,
  onCloseModal,
  onQuestionClick,
}) => {
  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['title']}>Ответы на вопросы</div>
      <div className={style['list']}>
        {answersOnQuestions.map((block, index) => (
          <div key={index} onClick={() => onActiveBlock(block)} className={style['item']}>
            <div className={style['count']}>
              {block.answers.length} {plural(block.answers.length, ['вопрос', 'вопроса', 'вопросов'])}
            </div>
            <BlockTitle>{block.title}</BlockTitle>
          </div>
        ))}
      </div>
      <ModalWindow
        open={modalVisible}
        content={<AnswersOnQuestionsItem onItemClick={onQuestionClick} {...activeBlock} />}
        onClose={onCloseModal}
      />
    </div>
  );
};
